"use client";

import { usePathname } from "@/i18n/navigation";
import { useEffect, useState } from "react";
import { useSupportAgentConfig } from "./SupportAgent/ConfigProvider";
import { AgentVisibilityProvider, useAgentVisibility } from "./SupportAgent/VisibilityProvider";
import { FloatingAgentWrapper } from "@ui/components/core/FloatingAgent/FloatingAgentWrapper";

function FloatingAgent({ hiddenPaths }: { hiddenPaths: string[] }) {
  const pathname = usePathname();
  const [isVisible, setIsVisible] = useState(false);
  const { isFooterVisible, isOmniboxVisible } = useAgentVisibility();
  const { config, hasActiveCall } = useSupportAgentConfig();

  // Handle pathname-based visibility
  useEffect(() => {
    const shouldHide = hiddenPaths.some(hiddenPath => pathname.includes(hiddenPath));
    setIsVisible(!shouldHide);
  }, [pathname, hiddenPaths]);

  // Combine all visibility conditions
  // - config.hidden: Page explicitly wants to hide layout agent (e.g., has its own custom agent)
  // - hasActiveCall: Keep visible during active call when navigating to hidden paths
  // Note: config.hidden takes precedence because if a page has a custom agent, any active call
  // belongs to that agent, not this layout-level one
  const shouldShow =
    (config.customAgentId || !config.hidden) && (hasActiveCall || (isVisible && !isFooterVisible && !isOmniboxVisible));

  return (
    <div
      className={`transition-opacity duration-300 ease-in-out ${!shouldShow ? "pointer-events-none opacity-0" : "opacity-100"}`}
      inert={!shouldShow || undefined}
    >
      <FloatingAgentWrapper />
    </div>
  );
}

export default function SupportAgentDynamic({ hiddenPaths }: { hiddenPaths: string[] }) {
  return (
    <AgentVisibilityProvider>
      <FloatingAgent hiddenPaths={hiddenPaths} />
    </AgentVisibilityProvider>
  );
}
